import React from "react";
import "./css/ProviderContainer.scss";
import Buttons from "./Buttons";

const ProviderContainer = ({
  title,
  image,
  maindesc,
  desc,
  footer,
  customParams,
}) => {
  return (
    <div className='image-box'>
      <div className='text-container'>
        <div className='title'>{title}</div>
        <div className='main-desc'>{maindesc}</div>
        <div className='contact-details'>{footer}</div>
      </div>
      <div className='btn-container'>
        <Buttons
          text={"View Details"}
          color={"primary"}
          style={{ width: "100%" }}
          onClick={() => {
            customParams.setIsModalActive(true);
            customParams.setModalProps(customParams.props);
          }}
        />
      </div>
    </div>
  );
};

export default ProviderContainer;
